import styled from "styled-components";
import { PillButton } from "../../../../CommonComponents/commonStyles";
import {Row} from 'antd';
export const HeadWrap = styled.div`
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  margin-top: ${props => props.marginTop};
`;

export const HeadMedium = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h4};
  letter-spacing: 0.7px;
  color: ${props => props.theme.fontColors.headingColor};
  margin-right: 10px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    letter-spacing: 0.6px;
  }
`;

export const PillButtonEdit = styled(PillButton)`
  width: 71px;
  height: 23px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: HelveticaNeue-Medium !important;
  font-size: 14px;
  color: #006778;
  border-color: #d4d4d4;

  &:hover,
  &:focus {
    color: #006778;
    border-color: #d4d4d4;
  }
`;

export const EditIcon = styled.img`
  margin-left: 5px;
`;

export const HeadKeyStyle = styled.span`
  display: inline;
  font-family: HelveticaNeue;
  font-size: 16px;
  line-height: 1.5;
  color: #505050;
  margin: ${props => props.marginProp};

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const HeadValueStyle = styled(HeadKeyStyle)`
  margin: ${props => props.marginProp};
  font-family: HelveticaNeue-Bold;
  color: #022737;

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const CustomRow = styled(Row)`
  display: flex;
  flex-wrap: wrap;
`;

export const HeadKeyStyleDiv = styled.div`
  font-family:  ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.colors.tabHead};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 1.5;
  margin: ${props => props.marginProp};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;